export default {
  "bank-logo": "_bank-logo_19t0pr",
  "text-link": "_text-link_19t0pr",
  "input-container": "_input-container_19t0pr",
  "checkbox": "_checkbox_19t0pr"
};
